import { useEffect } from "react";
import { gql, useApolloClient } from "@apollo/client";
import {
  useAvailableOrgCountQuery,
  useMeUserIdQuery,
} from "./usePurgeCacheOnUserChange.generated";
import { usePollInterval } from "./usePollInterval";

export const usePurgeCacheOnUserChange = (): void => {
  const { data: availableOrgCount } = useAvailableOrgCountQuery();
  const pollInterval = usePollInterval(5000);

  const { data, previousData } = useMeUserIdQuery({
    pollInterval,
    skip: availableOrgCount?.Me?.availableOrgs?.totalCount === 1,
  });
  const apollo = useApolloClient();
  const previousUserId = previousData?.Me?.user?.id;
  const currentUserId = data?.Me?.user?.id;
  useEffect(() => {
    if (currentUserId && previousUserId && currentUserId !== previousUserId) {
      apollo.resetStore();
    }
  }, [previousUserId, currentUserId]); // eslint-disable-line react-hooks/exhaustive-deps
};

gql`
  query MeUserId {
    Me {
      user {
        id
      }
    }
  }

  query AvailableOrgCount {
    Me {
      availableOrgs(input: {}) {
        totalCount
      }
    }
  }
`;
